import React from "react";
import "./style.css";
import ChallanGeneratedGraph from "./Common/ChallanGeneratedGraph";
import ChallaRequestReceived from "./Common/ChallanRequestReceived";
import FuelStatusGraph from "./Common/FuelStatusGraph";
import FuelConsumptionReport from "./Common/FuelConsumptionReport";
import WorkshopReport from "./Common/WorkshopReport";
import DutyReports from "./Common/DutyReports";
import GoodsRequested from "./Common/GoodsRequested";
import InvoiceGeneratedGraph from "./Common/InvoiceGeneratedGraph";
import DefectWiseReport from "./Jallipool/DefectWiseReport";

function JallipoolDashboard() {
  return (
    <>
      <div className="row m-0">
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <WorkshopReport depo="10" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <DefectWiseReport />
          </div>
        </div>
        <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3">
            <GoodsRequested depo="10" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <ChallaRequestReceived depo="2" />
          </div>
        </div>

        {/* Removed  */}
        {/* <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{height: "410px"}}>
            <DutyReports />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3">
            <ChallanGeneratedGraph depo="10" />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelStatusGraph />
          </div>
        </div>
        <div className="col col-12 col-md-6 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <FuelConsumptionReport />
          </div>
        </div> */}
        {/* <div className="col col-12 col-md-12 col-lg-6">
          <div className="graph-outline mb-3" style={{ height: "400px" }}>
            <InvoiceGeneratedGraph depo="10" />
          </div>
        </div> */}
      </div>
    </>
  );
}

export default JallipoolDashboard;
